<template>
  <NavMenu :target-el :title="textTitle" @close="emit('close')">
    <div class="container-screen">
      <p class="small dim screen-link-text">{{ link }}</p>
      <div class="button-wrapper">
        <button
          class="button-medium button-secondary btn-fullwidth"
          :class="{ done: isURLCopied }"
          @click="copyToClipboard"
        >
          {{ isURLCopied ? $t('copy_completed') : $t('urlcopy') }}
        </button>
        <button class="button-medium button-secondary btn-fullwidth" @click="openLink">
          {{ $t('open') }}
        </button>
      </div>
      <button v-if="isVisibleMultiScreen" class="button-medium button-secondary btn-fullwidth" @click="openMultiScreen">
        {{ t('open_multi_screen_mode') }}
      </button>
    </div>
  </NavMenu>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import NavMenu from '@/components/shared/composite/NavMenu.vue';
import { useCallStore } from '@/stores/call';
import { useUserStore } from '@/stores/user';
import { Nullable } from '@/types/common';

const userStore = useUserStore();

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    mode: 'screen' | 'subtitle';
    targetEl: Nullable<HTMLElement>;
  }>(),
  {
    mode: '',
  }
);

const emit = defineEmits<{
  close: [];
}>();

const callStore = useCallStore();

const isModeScreen = props.mode === 'screen';

const link = computed<string>(() => {
  return `${window.location.origin}/chat/${props.mode}?code=${callStore.qrCodeInfo.guestCode}`;
});

const textTitle = computed(() => {
  return isModeScreen ? t('screen_view') : t('subtitle_view');
});

const isVisibleMultiScreen = computed(() => {
  const isPNU = [1341, 39, 94, 2, 1212, 1748, 2081].includes(userStore.partnerId);
  return isModeScreen && isPNU;
});

const openLink = () => {
  window.open(link.value, '_blank');
};

const openMultiScreen = () => {
  const link = `${window.location.origin}/chat/screen-dual?guestCode=${callStore.qrCodeInfo.guestCode}`;
  window.open(link, '_blank');
};

const isURLCopied = ref(false);

const copyToClipboard = () => {
  navigator.clipboard.writeText(link.value).then(
    () => {
      isURLCopied.value = true;
      setTimeout(() => {
        isURLCopied.value = false;
      }, 10000);
    },
    () => {}
  );
};
</script>

<style scoped lang="scss">
.share-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.25rem;
}

.container-screen {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.screen-link-text {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  border-radius: 8px;
  border: 1px solid var(--border-default);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.button-wrapper {
  display: flex;
  gap: 0.25rem;
}

.button-small.done {
  color: var(--color-gray-900);
  background-color: var(--color-white);
  cursor: default;
  text-decoration: none;
}

.button-small.done:hover {
  background-color: var(--color-white);
}
</style>
